/**
 * User class to store all user information
 * - All api endpoints should be called through this class
 * - User class will be set to window.user on 'DOMContentLoaded'
 */

window.user = new class {
  constructor () {
    if (typeof window.customerJSON === 'undefined') { return }
    this._userInfo = window.customerJSON
  }

  get userInfo () {
    return this._userInfo
  }

  /**
   * Function to connect with the app's API endpoings
   * @param {string} apiEndpoint : API endpoint
   * @param {string} method : GET, POST, PUT, DELETE
   * @param {object} body : object of body data
   * @returns the response of null if error
   */
  async apiConnect (apiEndpoint, method = 'GET', body = null) {
    try {
      const options = {
        method,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        }
      }

      if (body) { options.body = JSON.stringify(body) }
      return await fetch(`/tools/e-learning/${apiEndpoint}`, options)
        .then(async (response) => {
          const jsonRes = await response.json()
          if (!response.ok) { throw new Error(jsonRes.error) }
          return jsonRes
        })
    } catch (err) {
      console.error(err)
      this.alertServerError()
      return null
    }
  }

  alertServerError () {
    return alert(
      'Cannot connect with the server, please try again. Contact support if the issue persists.'
    )
  }
}()
